<div class="d-flex h-100">
  <div [ngClass]="this.hasDetail ? 'd-none' : 'd-block'"
       class="d-xl-block"
       [style.flex-grow]="flexGrowLeft"
       [style.min-width.%]="(flexGrowLeft / (+flexGrowLeft + +flexGrowRight)) * 100">
    <ng-content select="era-master"></ng-content>
  </div>
  <div [ngClass]="this.hasDetail ? 'd-block' : 'd-none'"
       class="d-xl-block bg-gray-100 border-start"
       [style.flex-grow]="flexGrowRight"
       [style.min-width.%]="(flexGrowRight / (+flexGrowLeft + +flexGrowRight)) * 100">
    <div class="close-container d-flex pe-3 pt-1 d-xl-none"
         [class.pt-sm-3]="isH2"
         [class.pt-2]="!isH2">
      <span class="mb-0"
            [class.h2]="isH2"
            [class.h4]="!isH2">&nbsp;</span>
      <button type="button"
              routerLink="./"
              class="close"
              aria-label="Close"
              (click)="deactivated()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="h-100 overflow-y-auto">
      <router-outlet (activate)="activated()"
                     (deactivate)="deactivated()"></router-outlet>
    </div>
  </div>
</div>